"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Models = require("./models");
exports.ManagedLabsModels = Models;
var Mappers = require("./models/mappers");
exports.ManagedLabsMappers = Mappers;
var msRest = require("ms-rest-js");
var msRestAzure = require("ms-rest-azure-js");
var operations = require("./operations");
var packageName = "@azure-lab-services/ml-ts";
var packageVersion = "42.42.4242";
var ManagedLabsClient = /*#__PURE__*/function (_msRestAzure$AzureSer) {
  /**
   * @class
   * Initializes a new instance of the ManagedLabsClient class.
   * @constructor
   *
   * @param {msRest.ServiceClientCredentials} credentials - Credentials needed for the client to connect to Azure.
   *
   * @param {string} subscriptionId - The subscription ID.
   *
   * @param {string} [baseUri] - The base URI of the service.
   *
   * @param {object} [options] - The parameter options
   *
   * @param {Array} [options.filters] - Filters to be added to the request pipeline
   *
   * @param {object} [options.requestOptions] - The request options. Detailed info can be found at
   * {@link https://github.github.io/fetch/#Request Options doc}
   *
   * @param {boolean} [options.noRetryPolicy] - If set to true, turn off default retry policy
   *
   * @param {string} [options.acceptLanguage] - Gets or sets the preferred language for the response.
   *
   * @param {number} [options.longRunningOperationRetryTimeout] - Gets or sets the retry timeout in seconds for Long Running Operations. Default value is 30.
   *
   * @param {boolean} [options.generateClientRequestId] - When set to true a unique x-ms-client-request-id value is generated and included in each request. Default is true.
   *
   */
  function ManagedLabsClient(credentials, subscriptionId, baseUri, options) {
    var _this;
    _classCallCheck(this, ManagedLabsClient);
    if (credentials === null || credentials === undefined) {
      throw new Error('\'credentials\' cannot be null.');
    }
    if (subscriptionId === null || subscriptionId === undefined) {
      throw new Error('\'subscriptionId\' cannot be null.');
    }
    if (!options) options = {};
    _this = _callSuper(this, ManagedLabsClient, [credentials, options]);
    _this.apiVersion = '2019-01-01-preview';
    _this.acceptLanguage = 'en-US';
    _this.longRunningOperationRetryTimeout = 30;
    _this.generateClientRequestId = true;
    _this.baseUri = baseUri;
    if (!_this.baseUri) {
      _this.baseUri = 'https://management.azure.com';
    }
    _this.credentials = credentials;
    _this.subscriptionId = subscriptionId;
    _this.addUserAgentInfo("".concat(packageName, "/").concat(packageVersion));
    if (options.acceptLanguage !== null && options.acceptLanguage !== undefined) {
      _this.acceptLanguage = options.acceptLanguage;
    }
    if (options.longRunningOperationRetryTimeout !== null && options.longRunningOperationRetryTimeout !== undefined) {
      _this.longRunningOperationRetryTimeout = options.longRunningOperationRetryTimeout;
    }
    if (options.generateClientRequestId !== null && options.generateClientRequestId !== undefined) {
      _this.generateClientRequestId = options.generateClientRequestId;
    }
    _this.providerOperations = new operations.ProviderOperations(_this);
    _this.globalUsers = new operations.GlobalUsers(_this);
    _this.labAccounts = new operations.LabAccounts(_this);
    _this.operations = new operations.Operations(_this);
    _this.galleryImages = new operations.GalleryImages(_this);
    _this.labs = new operations.Labs(_this);
    _this.environmentSettings = new operations.EnvironmentSettings(_this);
    _this.environments = new operations.Environments(_this);
    _this.schedules = new operations.Schedules(_this);
    _this.users = new operations.Users(_this);
    _this.sharedGalleries = new operations.SharedGalleries(_this);
    _this.sharedImages = new operations.SharedImages(_this);
    _this.serializer = new msRest.Serializer(Mappers);
    return _this;
  }
  _inherits(ManagedLabsClient, _msRestAzure$AzureSer);
  return _createClass(ManagedLabsClient);
}(msRestAzure.AzureServiceClient);
exports.ManagedLabsClient = ManagedLabsClient;